/*
 * Navigation Messages
 */
import { defineMessages } from 'react-intl';

const scope = 'navigation';

export default defineMessages({
  logoName: {
    id: `${scope}.logoName`,
    defaultMessage: 'Bronte',
  },
  logoTag: {
    id: `${scope}.logoTag`,
    defaultMessage: 'Beta',
  },
});
